import Image from 'next/image';
import { BlogPost } from '../../lib/blog';

type Props = {
  post: BlogPost;
};

export const BlogPostAuthor = ({ post }: Props) => {
  const { author } = post;

  if (!author) return null;

  const { thumbnail, name, title } = author;

  return (
    <div className="post-author mt-4">
      <div className="thumbnail col">
        <div className="thumbnail-cover relative flex items-center justify-center">
          <Image
            src={thumbnail.url}
            alt={name}
            width={100}
            height={100}
            objectFit="contain"
          />
        </div>
      </div>
      <div className="content col">
        <p className="name text-lg font-black text-black">{name}</p>
        {title && (
          <p className="title p-body text-gray-dark/70 text-sm">{title}</p>
        )}
      </div>
    </div>
  );
};
